import React from "react";

const BimPage: React.FC = () => {
    return (
        <></>
    )
}
export default BimPage;